import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Component bảo vệ route dành cho admin
 * Chỉ cho phép người dùng có quyền admin truy cập
 * Nếu không có quyền, chuyển hướng về trang chủ hoặc trang lỗi 403
 */
const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Kiểm tra xem người dùng có quyền admin không
    // Đây chỉ là triển khai đơn giản, thực tế cần gọi API hoặc sử dụng context
    const checkAdmin = async () => {
      try {
        // Kiểm tra token
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        
        if (!token) {
          setIsAdmin(false);
          return;
        }
        
        // Giả định rằng có một trường isAdmin trong localStorage để kiểm tra
        // Thực tế cần kiểm tra quyền từ JWT hoặc gọi API
        const userRole = localStorage.getItem('userRole');
        setIsAdmin(userRole === 'admin');
      } catch (error) {
        console.error('Lỗi khi kiểm tra quyền admin:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, []);

  // Nếu đang kiểm tra, hiển thị loading
  if (loading) {
    return <div>Đang kiểm tra quyền truy cập...</div>;
  }

  // Nếu không phải admin, chuyển hướng về trang chủ
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Nếu là admin, hiển thị component con
  return <>{children}</>;
};

export default AdminProtectedRoute; 